import React from "react";
import { Form, Input, Spin } from "antd";
import { EComModal } from "components/EComModal";
import { AiccScenarioCategory, AiccScenarioCategoryPayload } from "types/model/aiccLearningAssets";
import { trimValues, useAssetFormModal } from "../hooks/useAssetFormModal";

const MAX_LENGTH = {
  name: 50,
  description: 1000,
};

interface Props {
  visible: boolean;
  category?: AiccScenarioCategory;
  isSaving: boolean;
  onCancel: () => void;
  onSubmit: (payload: AiccScenarioCategoryPayload) => void;
}

const toFormValues = (category?: AiccScenarioCategory) => ({
  name: category?.name,
  description: category?.description,
});

function ScenarioCategoryModal({ visible, category, isSaving, onCancel, onSubmit }: Props) {
  const form = useAssetFormModal<AiccScenarioCategoryPayload, AiccScenarioCategory>(visible, category, toFormValues);
  const isEditing = !!category;

  const handleOk = () => form.validateFields().then((values) => onSubmit(trimValues(values)));

  return (
    <EComModal
      visible={visible}
      title={isEditing ? "Edit Scenario Category" : "Add Scenario Category"}
      okText="Save"
      onOk={handleOk}
      onCancel={onCancel}
      isSaving={isSaving}
    >
      <Spin spinning={isSaving} size="large">
        <Form form={form} layout="vertical">
          <Form.Item label="Category" name="name" rules={[{ required: true, message: "Please enter a category." }]}>
            <Input placeholder="e.g. Your Travel Toolkit" maxLength={MAX_LENGTH.name} />
          </Form.Item>
          <Form.Item
            label="Category Description"
            name="description"
            rules={[{ required: true, message: "Please enter a category description." }]}
          >
            <Input.TextArea
              rows={4}
              maxLength={MAX_LENGTH.description}
              showCount
              placeholder="Essential conversations for confident exploration"
            />
          </Form.Item>
        </Form>
      </Spin>
    </EComModal>
  );
}

export default ScenarioCategoryModal;
